import React, { ChangeEvent, Component, Fragment, useEffect, useRef, useState } from "react";
import {} from "../../core/feature/store";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";
import Company from "../../core/models/company";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import User from "../../core/models/user";
import _, { find } from "lodash";
import "react-multi-carousel/lib/styles.css";
import * as api_info from "../../core/service/api_info";
import {
  getAllInvoice,
  getAllInvoicePaid,
  getAllInvoiceSummary,
  invoicePayment,
} from "../../core/service/api_invoice";
import Config from "../../config/Config";
import userweb from "../../assets/images/icon_home/userweb.svg";
import dot from "../../assets/images/icon_home/dot-balance.svg";
import kanan from "../../assets/images/icon_home/tangankanan.svg";
import kiri from "../../assets/images/icon_home/tangankiri.svg";
import logo from "../../assets/images/icon_home/logoweb.svg";
import notif from "../../assets/images/icon_home/notif.svg";
import Navbar from "../common/Navbar";
import moment from "moment";
import bola from "../../assets/images/info/bola.svg";
import { useDispatch } from "react-redux";
import filter from "../../assets/images/icon_invoice/filter.svg";
import diskon from "../../assets/images/icon_invoice/discount.svg";
import book from "../../assets/images/icon_invoice/invoice.svg";
import axios from "axios";
import { setLoading } from "../../core/feature/config/configSlice";
import { StatsInvoice } from "../common/home/Stats";
import { formatCurrency } from "../../config/global";
import success from "../../assets/images/icon_invoice/success.svg";
import { Dialog, Transition } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import { removeUser } from "../../core/feature/user/userSlice";
import { getBalance } from "../../core/service/api_balance";
import CustomApp from "../../core/models/customApp";
import { toast } from "react-toastify";
import {
  removeBalance,
  setBalance,
} from "../../core/feature/user/balanceSlice";
import CurrencyInput from "react-currency-input-field";
import { BackButton } from "../common/BackButton";
import {
  FacebookIcon,
  FacebookShareButton,
  TelegramIcon,
  TelegramShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import * as htmlToImage from "html-to-image";
import html2canvas from "html2canvas";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import { isDarkColor } from "../../config/DarkColorChecker";

const ComponentInvoice = () => {
  const gaEventTracker = useAnalyticsEventTracker("Transaction");

  const customApp: CustomApp = useAppSelector(
    (state) => state.customApp.customApp
  );
  const balance: any = useAppSelector((state) => state.balance.balance);
  const [data, setData] = useState<any>([]);
  const [dataSumary, setDataSumary] = useState<any>([]);
  const user: User = useAppSelector((state) => state.user.user);
  const dispatch = useDispatch();
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const navigate = useNavigate();
  const [total, setTotal] = useState(0);
  const [showPayment, setShowPayment] = useState(false);
  const [showPin, setShowPin] = useState(false);
  const [confirmation, setConfirmation] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [dataTemp, setDatatemp] = useState<any>({});
  const [isShowMore, setIsShowMore] = useState(false);
  const [showDescription, setShowDescription] = useState(true);
  const [showSort, setShowSort] = useState(false);

  const { t } = useTranslation();
  var invoicea = `${t("INVOICE.title")}`;
  var history = `${t("INVOICE.history")}`;
  var summary = `${t("INVOICE.summary")}`;
  var nominal = `${t("INVOICE.placeholder")}`;
  var cash = `${t("INVOICE.cash")}`;
  var paid = `${t("INVOICE.paid")}`;
  var unpaid = `${t("INVOICE.unpaid")}`;
  var partial = `${t("INVOICE.partial")}`;
  const [amount, setAmount] = useState<any>("");
  const [paymentSuccess, setPaymentSuccess] = useState<any>([]);
  const shareButton = useRef<HTMLButtonElement>(null);
  const [url, setUrl] = useState<string>("none");
  const ref = useRef<HTMLDivElement>(null);
  let [isOpen, setIsOpen] = useState(false);
  const [sortBy, setSortBy] = useState('invoiceDate_Desc')

  useEffect(() => {
    getData(page, size);
  }, []);

    const sortingOptions = [
  { label: t('SORTING.invoiceDateDesc'), value: "invoiceDate_Desc" },
  { label: t('SORTING.invoiceDateAsc'), value: "invoiceDate_Asc" },
  { label: t('SORTING.dueDateAsc'), value: "dueDate_Asc" },
  { label: t('SORTING.dueDateDesc'), value: "dueDate_Desc" },
  { label: t('SORTING.amountAsc'), value: "amount_Asc" },
  { label: t('SORTING.amountDesc'), value: "amount_Desc" }
];

const handleSortChange = (e: ChangeEvent<HTMLInputElement>) => {
    const sortData = e.target.value
      setSortBy(sortData)
  }



  const [active, setActive] = useState("all");
  const getData = async (newPage: any, newSize: any) => {
    dispatch(setLoading(true));
    const sort = sortBy.split('_')
    getAllInvoice(newSize, newPage, sort[0], sort[1], "", "")
      .then((res: any) => {
        setData(res.data.content);
        setTotal(res.data.totalElements);
        dispatch(setLoading(false));
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };


  useEffect(() => {
  if (sortBy) {
    getData(page, size);
    dismissSortDialog()
  }
}, [sortBy]);


  const paymentAction = async () => {
    setShowPayment(false);
    setIsOpen(true);
  };
  const closeAction = async () => {
    setIsOpen(false);
  };

  const openSortDialog = () => {
    setShowSort(true)
  }

  const dismissSortDialog = () => {
    setShowSort(false);
  }

  const getInvoicePaid = (newPage: any, newSize: any) => {
    dispatch(setLoading(true));
    getAllInvoicePaid(newSize, newPage, "Desc", "", "")
      .then((res: any) => {
        dispatch(setLoading(false));
        setData(res.data.content);
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
        console.log(err);
      });
  };

  const getInvoiceSummary = (newPage: any, newSize: any) => {
    dispatch(setLoading(true));
    getAllInvoiceSummary(newSize, newPage, "Desc", "", "")
      .then((res: any) => {
        dispatch(setLoading(false));
        setDataSumary(res.data.content);
        setTotal(res.data.totalElements);
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
        navigate("/login", { replace: true });
      });
  };

  const changePage = (newPage: any) => {
    setPage(newPage);

    if (active == "all") {
      return getData(newPage, size);
    }
    if (active == "history") {
      return getInvoicePaid(newPage, size);
    }
    if (active == "summary") {
      getInvoiceSummary(newPage, size);
    }
  };

  const changeSize = (newSize: any) => {
    setSize(newSize);
    if (active == "all") {
      return getData(page, newSize);
    }
    if (active == "history") {
      return getInvoicePaid(page, newSize);
    }
    if (active == "summary") {
      getInvoiceSummary(page, newSize);
    }
  };

  const paymentInvoice = async (data: any) => {
    var unpaidAmount: any = data.amount - data.paidAmount;

    var tempAmount;

    if (data.partialMethod == true) {
      if (parseInt(amount) > unpaidAmount) {
        return toast.warning(
          t("INVOICE.amountNotValid") + formatCurrency(unpaidAmount)
        );
      }
      if (
        unpaidAmount - parseInt(amount) < 10000 &&
        unpaidAmount > 10000 &&
        unpaidAmount != parseInt(amount)
      )
        return toast.warning(t("INVOICE.remainingPayment"));

      if (parseInt(amount) > unpaidAmount)
        return toast.warning(
          t("INVOICE.amountNotValid") + formatCurrency(unpaidAmount)
        );
      if (parseInt(amount) < 10000 && unpaidAmount > 10000)
        return toast.warning(t("INVOICE.placeholder"));
      if (balance < parseInt(amount))
        return toast.warning(
          t("INVOICE.balanceEmpty") + formatCurrency(balance)
        );

      tempAmount = amount;
    } else {
      if (balance < unpaidAmount) {
        return toast.warning(
          t("INVOICE.balanceEmpty") + formatCurrency(balance)
        );
      }
      tempAmount = unpaidAmount.toString();
    }
    var query = {
      amount: parseInt(tempAmount),
      cash: true,
      channel: "MOBILE",
      invoiceId: data.invoiceId,
      tag: "",
    };

    dispatch(setLoading(true));
    invoicePayment(query)
      .then((res) => {
        dispatch(setLoading(false));
        getData(page, size);
        setActive("all");
        setShowPayment(false);
        setPaymentSuccess(res.data);
        getBalance()
          .then((res) => {
            dispatch(setBalance(res.data.balance));
          })
          .catch((err) => {
            dispatch(removeUser());
            dispatch(removeBalance());
            navigate("/login", { replace: true });
          });
        toast.success(t("OTHER.success"));
        gaEventTracker("Click Payment", "Payment Invoice Success");

        setShowResult(true);
      })
      .catch((err: any) => {
        console.log(err);
        dispatch(setLoading(false));
      });
  };

  const payment = (item: any) => {
    setDatatemp(item);
    setShowPayment(true);
    setShowPin(false);
    setConfirmation(false);
    setShowResult(false);
    if (item?.partialMethod !== false) {
      setAmount(String(item?.amount - item?.paidAmount));
    }
  };

  const pin = () => {
    setShowPayment(false);
    setShowPin(true);
    setConfirmation(false);
    setShowResult(false);
  };

  const confirm = () => {
    setShowPayment(false);
    setShowPin(false);
    setConfirmation(true);
    setShowResult(false);
  };

  const sukses = () => {
    setShowPayment(false);
    setShowPin(false);
    setConfirmation(false);
    setShowResult(true);
  };

  const canvasRef: any = useRef();
  const [image, setImage] = useState();

  const onClick = () => {
    setShowDescription(false);
    setTimeout(() => {
      downloadImage();
    }, 1000);
  };

  const downloadImage = () => {
    const input: any = document.getElementById("Detail");
    html2canvas(input, { logging: true, useCORS: true }).then(
      (canvas: HTMLCanvasElement) => {
        const url: any = canvas.toDataURL();
        setImage(url);
        const linkSource = url;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = dataTemp?.title + " - " + dataTemp?.callerName;
        downloadLink.click();
        setShowDescription(true);
      }
    );
  };

  const onClick2 = () => {
    const input: any = document.getElementById("DetailPay");
    html2canvas(input, { logging: true, useCORS: true }).then(
      (canvas: HTMLCanvasElement) => {
        const url: any = canvas.toDataURL();
        setImage(url);
        const linkSource = url;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = dataTemp?.title + " - " + dataTemp?.callerName;
        downloadLink.click();
      }
    );
  };

  return (
    <div className="bg-psp-primary pb-20 font-montserrat">
      <StatsInvoice />
      <div className="container relative w-full -mt-44 bg-white shadow rounded-2xl pb-10">
        <div className="container h-full w-full">
          <div className="flex p-4">
            <BackButton />
            <div className="text-4xl font-bold">{invoicea}</div>
          </div>
          <div className="pb-4">
            {["all", "history", "summary"].map((x) => {
              return (
                <button
                  onClick={() => {
                    switch (x) {
                      case "all":
                        getData(page, size);
                        break;
                      case "history":
                        getInvoicePaid(page, size);
                        break;
                      case "summary":
                        getInvoiceSummary(page, size);
                        break;
                    }
                    setActive(x);
                  }}
                  style={
                    active === x
                      ? {
                          backgroundColor: customApp.app_accent_color,
                          color: isDarkColor(customApp.app_accent_color)
                            ? "white"
                            : "black",
                        }
                      : { color: "grey" }
                  }
                  className={
                    active == x
                      ? `px-4 py-2 ml-3 rounded-full text-lg ${
                          isDarkColor(customApp.app_accent_color)
                            ? "text-white hover:text-white"
                            : "text-black hover:text-black"
                        }`
                      : "px-4 py-2 ml-3 rounded-full text-lg hover:font-semibold"
                  }
                >
                  {t(`INVOICE.${x == "all" ? "title" : x}`)}
                </button>
              );
            })}
          </div>
          {active === "summary" ? (
            <div>
              <div className="container">
                <div className="container rounded-xl px-3 ">
                  <div>
                    <div>
                      <div className="flex flex-col  relative justify-center items-center">
                        <div className="w-full ">
                          <div className=" w-full  relative flex">
                            <div className=" relative  w-full sm:rounded-lg">
                              <div className="flex w-full flex-row justify-start my-2">
                                <h2 className="text-slate-400 text-2xl font-montserrat text-left">
                                  {invoicea}
                                </h2>
                              </div>
                              <table className=" w-full shadow-xl rounded-lg">
                                <thead
                                  className={`text-xs uppercase rounded-xl ${
                                    isDarkColor(customApp.app_accent_color)
                                      ? "text-white"
                                      : "text-black"
                                  }`}
                                  style={{
                                    background: customApp.app_accent_color,
                                  }}
                                >
                                  <tr>
                                    <th
                                      scope="col"
                                      className="py-3 px-6 text-[0.7vw] font-montserrat"
                                    >
                                      {t("INVOICE.date")}
                                    </th>
                                    <th scope="col" className="py-3 px-6">
                                      <div className="flex items-center text-[0.7vw] font-montserrat">
                                        {t("INVOICE.title")}
                                      </div>
                                    </th>
                                    <th scope="col" className="py-3 px-6">
                                      <div className="flex items-center text-[0.7vw] font-montserrat">
                                        {t("INVOICE.total")}
                                      </div>
                                    </th>
                                    <th scope="col" className="py-3 px-6">
                                      <div className="flex items-center text-[0.7vw] font-montserrat">
                                        {t("INVOICE.paid")}
                                      </div>
                                    </th>
                                    <th scope="col" className="py-3 px-6">
                                      <div className="flex items-center text-[0.7vw] font-montserrat">
                                        {t("INVOICE.totalDue")}
                                      </div>
                                    </th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {dataSumary.map((item: any, index: any) => {
                                    return (
                                      <tr
                                        key={index}
                                        className="bg-white border-b dark:bg-gray-800 cursor-pointer"
                                      >
                                        <th
                                          scope="row"
                                          className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap text-[1vw] dark:text-white"
                                        >
                                          {moment(item.createDate).format(
                                            "DD-MM-YYYY"
                                          )}
                                        </th>
                                        <td className="py-4 px-6 text-left text-[1vw]">
                                          {item.title}
                                        </td>
                                        <td className="py-4 px-6 text-right text-[1vw]">
                                          {formatCurrency(item.amount)}
                                        </td>
                                        <td className="py-4 px-6 text-right text-[1vw]">
                                          {formatCurrency(item.paidAmount)}
                                        </td>
                                        <td className="py-4 px-6 text-right text-[1vw]">
                                          {formatCurrency(
                                            item.amount - item.paidAmount
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="flex relative mt-10 justify-between">
                      <div className="pt-2 w-1/4">
                        <p>
                          {t("OTHER.showing")} {page + 1} {t("OTHER.to")} {size}{" "}
                          {t("OTHER.from")} {total} data
                        </p>
                      </div>
                      <div className="w-auto">
                        <div className="">
                          <select
                            onChange={(value) => {
                              changeSize(value.target.value);
                            }}
                            value={size}
                            className="py-2 border rounded-lg bg-white"
                          >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={1000}>1000</option>
                          </select>
                          <span className="ml-1">{t("OTHER.entry")}</span>
                        </div>
                      </div>
                      <div className="flex w-1/4">
                        <button
                          onClick={() => changePage(page - 1)}
                          disabled={page === 0}
                          className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
                        >
                          {t("OTHER.previous")}
                        </button>
                        <button
                          onClick={() => changePage(page + 1)}
                          disabled={(page + 1) * size > total}
                          className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
                        >
                          {t("OTHER.next")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div>
              <h2 className="text-slate-400 text-2xl p-4">{invoicea}</h2>
              <div className="container">
                <div className="container rounded-xl px-3 ">
                  <button className="px-3 py-2.5 bg-psp-gray rounded-full text-white flex flex-row gap-3" onClick={() => openSortDialog()}>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
                        <path fillRule="evenodd" d="M6.97 2.47a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1-1.06 1.06L8.25 4.81V16.5a.75.75 0 0 1-1.5 0V4.81L3.53 8.03a.75.75 0 0 1-1.06-1.06l4.5-4.5Zm9.53 4.28a.75.75 0 0 1 .75.75v11.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 1 1 1.06-1.06l3.22 3.22V7.5a.75.75 0 0 1 .75-.75Z" clipRule="evenodd" />
                      </svg>
                      {t("INVOICE.sort")}
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                      </svg>
                    </button>
                  <div>
                    {data.map((item: any, index: any) => {
                      var diskonStatus = false;
                      item.detail.forEach((e: any, i: any) => {
                        if (e.discount !== 0) {
                          return (diskonStatus = true);
                        }
                      });
                      return (
                        <div
                          key={index}
                          className="text-dark text-lg mt-2 mb-4 container relative border rounded-xl"
                        >
                          <div className="border-b-2 border-b-slate-700">
                            <div className="inline-flex">
                              <img
                                className="mr-4 mt-3 ml-2"
                                alt=""
                                src={book}
                              />
                              <div className="mt-3 font-semibold text-[1.3vw]">
                                {item.title}
                              </div>
                            </div>
                            {diskonStatus ? (
                              <span className="mt-4 absolute right-0">
                                <img src={diskon} alt="diskon" />
                              </span>
                            ) : null}
                          </div>

                          <div className="flex flex-row relative justify-between">
                            <div className="flex flex-col relative w-4/12 mt-4 pb-4 text-slate-500">
                              <div className="flex flex-row relative">
                                <p className="text-[1vw]">
                                  {t("INVOICE.name")}
                                </p>
                              </div>
                              <div className="flex flex-row relative">
                                <p className="text-[1vw]">{t("INVOICE.nis")}</p>
                              </div>

                              <div className="flex flex-row relative">
                                <p className="text-[1vw]">
                                  {t("INVOICE.date")}
                                </p>
                              </div>
                            </div>
                            <div className="flex flex-col relative w-5/12 mt-4 pb-4 font-semibold">
                              <div className="flex flex-row relative">
                                <p className="text-[1vw]">
                                  {" : "} {item.callerName}
                                </p>
                              </div>
                              <div className="flex flex-row relative">
                                <p className="text-[1vw]">
                                  {" : "} {item.callerId}
                                </p>
                              </div>

                              <div className="flex flex-row relative">
                                <p className="text-[1vw]">
                                  {" : "}
                                  {moment(item.createDate).format(
                                    "DD MMMM YYYY"
                                  )}
                                </p>
                              </div>
                            </div>
                            <div className="flex flex-col relative w-5/12 mt-4 pb-4 text-slate-500">
                              <div className="contents">
                                <div className="flex flex-row relative">
                                  <p className="text-[1vw]">
                                    {t("INVOICE.credit")}
                                  </p>
                                </div>
                                <div className="flex flex-row relative">
                                  <p className="text-[1vw]">
                                    {t("INVOICE.paid")}
                                  </p>
                                </div>
                                <div className="flex flex-row relative">
                                  <p className="text-[1vw]">
                                    {t("INVOICE.limit")}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="flex flex-col relative w-5/12 mt-4 pb-4 font-semibold">
                              <div className="contents">
                                <div className="flex flex-row relative">
                                  <p className="text-[1vw]">
                                    {" : "}
                                    {item.partialMethod === false
                                      ? t("OTHER.no")
                                      : t("OTHER.yes")}
                                  </p>
                                </div>
                                <div className="flex flex-row relative">
                                  <p className="text-[1vw]">
                                    {" : "} {formatCurrency(item.paidAmount)}
                                  </p>
                                </div>
                                <div className="flex flex-row relative">
                                  <p className="text-[1vw]">
                                    {" : "}
                                    {moment(item.dueDate).format(
                                      "DD MMMM YYYY"
                                    )}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="flex flex-col relative w-2/12 mt-4 pb-4 items-end">
                              <h4 className="text-slate-400 text-[1vw]">
                                {t("INVOICE.sisa")}
                              </h4>
                              <p className="font-bold text-[1.5vw]">
                                {formatCurrency(item.amount - item.paidAmount)}
                              </p>
                              {active !== "all" ? (
                                <button
                                  onClick={() => payment(item)}
                                  style={{
                                    backgroundColor: customApp.app_accent_color,
                                  }}
                                  className={`h-[5vh] w-[10vw] rounded-xl hover:opacity-80 ${
                                    isDarkColor(customApp.app_accent_color)
                                      ? "text-white"
                                      : "text-black"
                                  }`}
                                >
                                  Detail
                                </button>
                              ) : (
                                <button
                                  onClick={() => payment(item)}
                                  style={{
                                    backgroundColor: customApp.app_accent_color,
                                  }}
                                  className={`h-[5vh] w-[10vw] rounded-xl hover:opacity-80 ${
                                    isDarkColor(customApp.app_accent_color)
                                      ? "text-white"
                                      : "text-black"
                                  }`}
                                >
                                  {t("INVOICE.pay")}
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    <div className="flex relative mt-10 justify-between">
                      <div className="pt-2 w-1/4">
                        <p>
                          {t("OTHER.showing")} {page + 1} {t("OTHER.to")} {size}{" "}
                          {t("OTHER.from")} {total} data
                        </p>
                      </div>
                      <div className="w-auto">
                        <div className="">
                          <select
                            onChange={(value) => {
                              changeSize(value.target.value);
                            }}
                            value={size}
                            className="py-2 border rounded-lg bg-white"
                          >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={1000}>1000</option>
                          </select>
                          <span className="ml-1">{t("OTHER.entry")}</span>
                        </div>
                      </div>
                      <div className="flex w-1/4">
                        <button
                          onClick={() => changePage(page - 1)}
                          disabled={page === 0}
                          className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
                        >
                          {t("OTHER.previous")}
                        </button>
                        <button
                          onClick={() => changePage(page + 1)}
                          disabled={(page + 1) * size > total}
                          className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
                        >
                          {t("OTHER.next")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <Transition appear show={isOpen} as={Fragment}>
          <Dialog as="div" className="relative z-10" onClose={closeAction}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black bg-opacity-25" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-medium leading-6 text-gray-900"
                    >
                      {t("INVOICE.confirm")}
                    </Dialog.Title>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">
                        {t("INVOICE.paymentConfirm")}
                      </p>
                    </div>

                    <div className="mt-4 flex gap-2 justify-center">
                      <button
                        type="button"
                        className="active:bg-zinc-100 inline-flex justify-center rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
                        onClick={() => closeAction()}
                      >
                        {t("OTHER.no")}
                      </button>
                      <button
                        type="button"
                        className="active:bg-psp-hover active:text-white inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                        onClick={() => paymentInvoice(dataTemp)}
                      >
                        {t("OTHER.yes")}
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
        <Transition
          show={showPayment && dataTemp?.creditDetailPayment === true}
          enter="transition-opacity duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
              <div className="relative w-full max-w-2xl mx-auto">
                <div className="border-0 rounded-2xl shadow-lg bg-white outline-none focus:outline-none">
                  <div className="flex justify-between items-center px-6 pt-6">
                    <div className="font-bold text-xl">
                      {t("INVOICE.title")}
                    </div>
                    {dataTemp?.detail?.some((e: any) => e.discount !== 0) && (
                      <span className="bg-red-500 text-white px-3 py-1 rounded-full text-xs ml-2">
                        Discount
                      </span>
                    )}
                    <button
                      className="text-2xl font-bold text-gray-400 hover:text-gray-600 ml-auto"
                      onClick={() => setShowPayment(false)}
                    >
                      &times;
                    </button>
                  </div>
                  <div className="flex flex-row px-6 py-4 gap-6">
                    <div className="flex-1 flex flex-col items-center justify-center border-r pr-6">
                      <div className="text-slate-500 text-sm mb-2">
                        Sisa Tagihan
                      </div>
                      <div className="text-red text-4xl font-bold mb-4">
                        Rp{" "}
                        {formatCurrency(dataTemp?.amount - dataTemp?.paidAmount)
                          .replace("Rp", "")
                          .trim()}
                      </div>
                      <div className="flex justify-between w-full text-center mt-4">
                        <div>
                          <div className="text-slate-400 text-xs">Terbayar</div>
                          <div className="font-semibold text-base">
                            Rp{" "}
                            {formatCurrency(dataTemp?.paidAmount)
                              .replace("Rp", "")
                              .trim()}
                          </div>
                        </div>
                        <div>
                          <div className="text-slate-400 text-xs">
                            Nominal Pembayaran
                          </div>
                          <div className="font-semibold text-base">
                            Rp{" "}
                            {formatCurrency(dataTemp?.amount)
                              .replace("Rp", "")
                              .trim()}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex-1 flex flex-col gap-2">
                      <div className="font-semibold mb-1 text-lg">
                        Data Pembayaran
                      </div>
                      <div>
                        <div className="flex justify-between items-center mb-2">
                          <div className=" w-1/2">Nama Orang Tua</div>
                          <div className="w-1/2 text-right">{user.name}</div>
                        </div>
                        <div className="flex justify-between items-center mb-2">
                          <div className="w-1/2">Nama Siswa</div>
                          <div className="w-1/2 text-right">
                            {dataTemp?.callerName}
                          </div>
                        </div>
                      </div>
                      <div className="font-semibold mb-1 text-lg">
                        Detail Tagihan
                      </div>
                      <div>
                        <div className="flex justify-between items-center mb-2">
                          <span>Nama Tagihan</span>
                          <span className="font-normal">{dataTemp?.title}</span>
                        </div>
                        <div className="flex justify-between items-center mb-2">
                          <span>Tgl Tagihan</span>
                          <span className="font-normal">
                            {moment(dataTemp?.invoiceDate).format("LL")}
                          </span>
                        </div>
                        <div className="flex justify-between items-center mb-2">
                          <span>Jatuh Tempo</span>
                          <span className="font-normal">
                            {moment(dataTemp?.dueDate).format("LL")}
                          </span>
                        </div>
                        <div className="flex justify-between items-center mb-2">
                          <span>Tipe Tagihan</span>
                          <span className="font-normal">
                            {dataTemp?.partialMethod === false
                              ? cash
                              : t("INVOICE.credit")}
                          </span>
                        </div>
                      </div>
                      <div className="font-semibold mb-1 text-lg">Rincian</div>
                      {dataTemp.detail?.map((item: any, index: any) => {
                        return (
                          <div key={index}>
                            <div className="flex justify-between items-center mb-2">
                              <span>{item.title}</span>
                              <span className="font-normal">
                                {formatCurrency(item.amount - item.discount)}
                              </span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="px-6 pb-6 flex justify-end">
                    <button
                      style={{
                        backgroundColor: customApp.app_accent_color,
                      }}
                      onClick={() =>
                        navigate(`/invoice-credit-payment`, {
                          state: { data: dataTemp },
                        })
                      }
                      className={`px-8 py-3 rounded-lg text-lg font-semibold shadow ${
                        isDarkColor(customApp.app_accent_color)
                          ? "text-white"
                          : "text-black"
                      }`}
                    >
                      {t("INVOICE.pay") || "Bayar Sekarang"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        </Transition>
        <Transition
          show={showPayment && dataTemp?.creditDetailPayment === false}
          enter="transition-opacity duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
              <div className="relative w-1/3 mx-10 flex  ">
                <div className="border-0 rounded-2xl shadow-lg min-w-[30vw] h-auto max-h-[95vh] overflow-y-auto overflow-x-hidden bg-white outline-none focus:outline-none">
                  <div className="relative py-6 px-6 flex-auto" id="Detail">
                    <div className="flex flex-row w-full h-auto">
                      <div className="font-montserrat text-slate-500  flex relative flex-col w-full">
                        {active !== "all" ? (
                          <div className="w-full">
                            <img
                              src={success}
                              alt=""
                              className="flex mx-auto"
                            ></img>
                            <p className="text-2xl text-center font-bold mt-4">
                              {t("INVOICE.success")}
                            </p>
                          </div>
                        ) : null}
                        <p className="font-bold text-center">
                          {dataTemp?.title}
                        </p>
                        {dataTemp?.description != "" && showDescription && (
                          <div>
                            {dataTemp?.description && (
                              <div
                                className="font-poppins font-normal text-sm text-psp-nav text-justify"
                                dangerouslySetInnerHTML={{
                                  __html:
                                    dataTemp?.description?.length > 100 &&
                                    !isShowMore
                                      ? dataTemp?.description
                                          .replaceAll(/\n/g, "<br>")
                                          .substring(0, 100) + "..."
                                      : dataTemp?.description.replaceAll(
                                          /\n/g,
                                          "<br>"
                                        ),
                                }}
                              ></div>
                            )}

                            <h1 className="font-poppins font-normal text-sm text-psp-nav text-justify">
                              {dataTemp?.description?.length > 100 && (
                                <span
                                  className="text-blue-600 underline cursor-pointer"
                                  onClick={() => setIsShowMore(!isShowMore)}
                                >
                                  {isShowMore
                                    ? t("INVOICE.showLess")
                                    : t("INVOICE.showMore")}
                                </span>
                              )}
                            </h1>
                          </div>
                        )}
                        <p className="font-bold">{t("INVOICE.dataInvoice")}</p>
                        <div
                          className={`w-full relative flex  flex-row justify-between ${
                            user.name == dataTemp?.callerName ? "hidden" : ""
                          }`}
                        >
                          <span className="my-2 font-montserrat">
                            {t("INVOICE.parentName")}
                          </span>
                          <span className="my-2 font-montserrat font-semibold">
                            {user.name}
                          </span>
                        </div>
                        <div className="w-full relative flex flex-row justify-between ">
                          <span className="my-2 font-montserrat w-1/2">
                            {t("INVOICE.studentName")}
                          </span>
                          <span className="my-2 font-montserrat font-semibold text-right w-1/2">
                            {dataTemp?.callerName}
                          </span>
                        </div>
                        <div className="w-full relative flex  flex-row justify-between">
                          <span className="  w-1/2 my-2 font-montserrat font-semibold  ">
                            {t("INVOICE.detailInvoice")}
                          </span>
                        </div>
                        <div className="w-full relative flex  flex-row justify-between">
                          <span className="  w-1/2 my-2 font-montserrat ">
                            {t("INVOICE.invoiceName")}
                          </span>
                          <span className="  w-1/2 my-2 font-montserrat font-semibold text-right">
                            {dataTemp?.title}
                          </span>
                        </div>
                        <div className="w-full relative flex  flex-row justify-between">
                          <span className="  w-1/2 my-2 font-montserrat">
                            {t("INVOICE.date")}
                          </span>
                          <span className="  w-1/2 my-2 font-montserrat font-semibold text-right">
                            {moment(dataTemp?.invoiceDate).format("LL")}
                          </span>
                        </div>
                        <div className="w-full relative flex  flex-row justify-between">
                          <span className="  w-1/2 my-2 font-montserrat">
                            {t("INVOICE.limit")}
                          </span>
                          <span className="  w-1/2 my-2 font-montserrat font-semibold text-right">
                            {moment(dataTemp?.dueDate).format("LL")}
                          </span>
                        </div>
                        <div className="w-full relative flex  flex-row justify-between">
                          <span className="  w-1/2 my-2 font-montserrat">
                            {t("INVOICE.invoiceType")}
                          </span>
                          <span className="  w-1/2 my-2 font-montserrat font-semibold text-right">
                            {dataTemp?.partialMethod == false
                              ? cash
                              : t("INVOICE.credit")}
                          </span>
                        </div>
                        <div className="w-full relative flex  flex-row justify-between border-b-2">
                          <span className="  w-1/2 my-2 font-montserrat">
                            Status
                          </span>
                          <span className="  w-1/2 my-2 font-montserrat font-semibold text-right">
                            {dataTemp?.status === "PAID"
                              ? paid
                              : dataTemp?.status === "UNPAID"
                              ? unpaid
                              : dataTemp?.status === "PARTIAL"
                              ? partial
                              : null}
                          </span>
                        </div>
                        {dataTemp?.detail?.map((res: any) => (
                          <div
                            className="w-full relative flex  flex-row justify-between items-center my-1"
                            hidden={!dataTemp?.showDetail}
                          >
                            <span>{res.title}</span>
                            <span className="my-1 font-montserrat font-semibold">
                              {formatCurrency(res.amount)}
                            </span>
                          </div>
                        ))}
                        <div className="w-full relative flex  flex-row justify-between">
                          <span className="my-2 font-montserrat">
                            {t("INVOICE.totalpay")}
                          </span>

                          <span className="my-2 font-montserrat font-semibold">
                            {formatCurrency(dataTemp?.amount)}
                          </span>
                        </div>
                        <div className="w-full relative flex  flex-row justify-between">
                          <span className="my-2 font-montserrat">
                            {t("INVOICE.paid")}
                          </span>

                          <span className="my-2 font-montserrat font-semibold">
                            {formatCurrency(dataTemp?.paidAmount)}
                          </span>
                        </div>
                        <div className="w-full relative flex  flex-row justify-between">
                          <span className="my-2 font-montserrat">
                            {t("INVOICE.minus")}
                          </span>
                          <span className="my-2 font-montserrat font-semibold">
                            {" "}
                            {formatCurrency(
                              dataTemp?.amount - dataTemp?.paidAmount
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="px-3 pb-3">
                    <div>
                      {dataTemp?.partialMethod !== false ? (
                        <form>
                          <CurrencyInput
                            className="px-3 py-3 mt-3 rounded-xl h-auto border-1 border-psp-border-gray border-solid active:border-0 w-full"
                            placeholder={nominal}
                            hidden={active !== "all" ? true : false}
                            decimalsLimit={2}
                            prefix={"Rp "}
                            value={
                              dataTemp?.amount - dataTemp?.paidAmount <= 10000
                                ? dataTemp?.amount - dataTemp?.paidAmount
                                : undefined
                            }
                            disabled={
                              dataTemp?.amount - dataTemp?.paidAmount <= 10000
                            }
                            onValueChange={(value, name) => {
                              setAmount(value || "");
                              value == undefined
                                ? setActive("all")
                                : setActive(active);
                            }}
                          />
                        </form>
                      ) : (
                        <form hidden>
                          <CurrencyInput
                            className="px-3 py-3 mt-3 rounded-xl h-auto border-1 border-psp-border-gray border-solid active:border-0 w-full"
                            placeholder={nominal}
                            hidden={active !== "all" ? true : false}
                            decimalsLimit={2}
                            prefix={"Rp "}
                            onValueChange={(value, name) => {
                              setAmount(value || "");
                              value == undefined
                                ? setActive("all")
                                : setActive(active);
                            }}
                          />
                        </form>
                      )}

                      {active == "all" ? (
                        <button
                          style={{
                            backgroundColor: customApp.app_accent_color,
                          }}
                          onClick={() => {
                            paymentAction();
                          }}
                          // onClick={() => paymentInvoice(dataTemp)}
                          className={`w-full py-3 rounded-lg mt-3 ${
                            isDarkColor(customApp.app_accent_color)
                              ? "text-white"
                              : "text-black"
                          }`}
                        >
                          {t("INVOICE.pay")}
                        </button>
                      ) : (
                        <button
                          style={{
                            backgroundColor: customApp.app_accent_color,
                          }}
                          onClick={() => onClick()}
                          className={`w-full py-3 rounded-lg mt-3 ${
                            isDarkColor(customApp.app_accent_color)
                              ? "text-white"
                              : "text-black"
                          }`}
                        >
                          Download
                        </button>
                      )}
                      <button
                        onClick={() => {
                          setShowPayment(false);
                          setShowPin(false);
                          setConfirmation(false);
                          setShowResult(false);
                        }}
                        className="w-full text-white bg-red py-3 rounded-lg mt-3"
                      >
                        {t("HOME.close")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        </Transition>

        <Transition
          show={showPin}
          enter="transition-opacity duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
              <div className="relative w-auto my-6 mx-auto max-w-3xl">
                <div className="border-0 rounded-2xl shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                  <div className="relative p-6 flex-auto">
                    <div>
                      <div className="flex pt-2">
                        <div className="w-full">
                          <p className="font-bold">Input Pin</p>
                          <form>
                            <input className="w-full py-2 border rounded-lg px-3 mb-3"></input>
                          </form>
                        </div>
                      </div>
                      <div className="flex flex-row gap-3">
                        <button className="w-full text-white bg-red py-2.5 px-5 rounded-lg">
                          Batal
                        </button>
                        <button
                          onClick={() => confirm()}
                          className="w-full text-white bg-psp-btn-primary py-2.5 px-5 rounded-lg"
                        >
                          Oke
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        </Transition>

        <Transition
          show={confirmation}
          enter="transition-opacity duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
              <div className="relative w-auto my-6 mx-auto max-w-3xl">
                <div className="border-0 rounded-2xl shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                  <div className="relative p-6 flex-auto">
                    <div>
                      <div className="flex pt-2 mb-3">
                        <div className="w-full">
                          <p className="font-bold text-xl">Konfirmasi</p>
                          <span>
                            Apakah anda yakin akan melakukan
                            <br /> pembayaran?
                          </span>
                        </div>
                      </div>
                      <div className="flex flex-row gap-3">
                        <button className="w-full text-white bg-red py-2.5 px-5 rounded-lg">
                          Batal
                        </button>
                        <button
                          onClick={() => sukses()}
                          className="w-full text-white bg-psp-btn-primary py-2.5 px-5 rounded-lg"
                        >
                          Oke
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        </Transition>

        <Transition
          show={showSort}
          enter="transition-opacity duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
              <div className="relative w-full my-6 mx-auto max-w-3xl">
                <div className="border-0 rounded-2xl shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                  <div className="relative p-6 flex-auto">
                    <div>
                      <div className="flex pt-2 mb-3">
                        <div className="w-full">
                          <p className="font-bold text-xl">{t("INVOICE.sort")}</p>
                           <div className="">
                            <div className="flex flex-column gap-2">

                              {sortingOptions.map((sort) => (
                                
                                  <label htmlFor={sort.value} className="p-4 border-b border-b-silver flex justify-between hover:bg-psp-hover hover:rounded-lg hover:text-white">{sort.label}
                                    <input onChange={(e) => handleSortChange(e)} id={sort.value} name="selectSortBy" checked={sortBy === sort.value}  className="w-5 h-5 border-2 border-psp-primary rounded-full" style={{ accentColor: customApp.app_accent_color }} type="radio" value={sort.value}/>
                                  </label>
                                
                                ))}
                              </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        </Transition>

        <Transition
          show={showResult}
          enter="transition-opacity duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-150"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <>
            <div className="justify-center items-center flex fixed inset-0 z-50 outline-none focus:outline-none">
              <div className="relative w-auto min-w-[30vw] h-auto max-h-[95vh] overflow-y-auto overflow-x-hidden my-6 mx-auto">
                <div className="border-0 rounded-2xl shadow-lg relative flex flex-col bg-white outline-none focus:outline-none">
                  <div
                    id="DetailPay"
                    className="relative px-6 pt-6 flex-auto w-auto"
                  >
                    <div className="flex flex-col">
                      <div className="w-full">
                        <img
                          src={success}
                          alt=""
                          className="flex mx-auto"
                        ></img>
                      </div>
                      <div className="text-center">
                        <p className="text-2xl font-bold mt-4">
                          {t("INVOICE.success")}
                        </p>
                        <span>
                          {t("MESSAGE.date")} :{" "}
                          {moment(paymentSuccess.dateTime).format(
                            "DD MMMM YYYY"
                          )}
                        </span>
                        <br />
                        <span>
                          {moment(paymentSuccess.dateTime).format("HH : mm")}
                        </span>
                      </div>
                    </div>
                    <div className="text-[1vw] mt-4">
                      <div className="w-full relative flex  flex-row justify-between">
                        <span className="my-2 font-montserrat font-semibold">
                          {t("INVOICE.dataInvoice")}
                        </span>
                      </div>
                      <div
                        className={`w-full relative flex  flex-row justify-between ${
                          user.name == dataTemp?.callerName ? "hidden" : ""
                        }`}
                      >
                        <span className="my-2 font-montserrat">
                          {t("INVOICE.parentName")}
                        </span>
                        <span className="my-2 font-montserrat font-semibold">
                          {user.name}
                        </span>
                      </div>
                      <div className="w-full relative flex flex-row justify-between">
                        <span className="my-2 font-montserrat w-1/2">
                          {t("INVOICE.studentName")}
                        </span>
                        <span className="my-2 font-montserrat font-semibold text-right w-1/2">
                          {dataTemp?.callerName}
                        </span>
                      </div>
                      <div className="w-full relative flex  flex-row justify-between">
                        <span className="my-2 font-montserrat font-semibold">
                          {t("INVOICE.detailInvoice")}
                        </span>
                      </div>
                      <div className="w-full relative flex  flex-row justify-between">
                        <span className="my-2 font-montserrat">
                          {t("INVOICE.invoiceName")}
                        </span>
                        <span className="my-2 font-montserrat font-semibold text-right">
                          {dataTemp?.title}
                        </span>
                      </div>
                      <div className="w-full relative flex  flex-row justify-between">
                        <span className="my-2 font-montserrat">
                          {t("INVOICE.invoiceType")}
                        </span>
                        <span className="my-2 font-montserrat font-semibold">
                          {dataTemp?.partialMethod == false
                            ? cash
                            : t("INVOICE.credit")}
                        </span>
                      </div>
                      <div className="w-full relative flex  flex-row justify-between">
                        <span className="my-2 font-montserrat text-white">
                          {t("INVOICE.invoiceType")}
                        </span>
                        <span className="my-2 font-montserrat font-semibold text-blue-400">
                          {t("INVOICE.success")}
                        </span>
                      </div>
                      {dataTemp?.detail?.map((res: any) => (
                        <div
                          className="w-full relative flex  flex-row justify-between items-center my-1"
                          hidden={!dataTemp?.showDetail}
                        >
                          <span>{res.title}</span>
                          <span className="my-1 font-montserrat font-semibold text-blue-400">
                            {formatCurrency(res.amount)}
                          </span>
                        </div>
                      ))}
                      <div className="w-full relative flex  flex-row justify-between">
                        <span className="my-2 font-montserrat">
                          {t("INVOICE.totalpay")}
                        </span>

                        <span className="my-2 font-montserrat font-semibold text-blue-400">
                          {formatCurrency(
                            paymentSuccess?.inquiryResponseDto?.amount
                          )}
                        </span>
                      </div>
                      <div className="w-full relative flex  flex-row justify-between border-t mb-6">
                        <span className="my-2 font-montserrat">
                          {t("INVOICE.minus")}
                        </span>
                        <span className="my-2 font-montserrat font-semibold">
                          {" "}
                          {formatCurrency(
                            paymentSuccess?.inquiryResponseDto?.amount -
                              (paymentSuccess?.inquiryResponseDto?.paidAmount +
                                paymentSuccess?.amount)
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="px-6 pb-6">
                    <div>
                      <button
                        onClick={() => onClick2()}
                        style={{
                          backgroundColor: customApp.app_accent_color,
                        }}
                        className={`w-full py-2.5 rounded-full mt-3 ${
                          isDarkColor(customApp.app_accent_color)
                            ? "text-white"
                            : "text-black"
                        }`}
                      >
                        Download
                      </button>
                      <button
                        onClick={() => setShowResult(false)}
                        className="w-full text-white bg-red py-2.5 rounded-full mt-3"
                      >
                        {t("OTHER.close")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        </Transition>
      </div>
    </div>
  );
};

export default ComponentInvoice;
